import React from "react";
import { UdyogLogo } from "@/components/UdyogLogo";

/**
 * A render crash inside the meeting used to leave a completely black screen
 * with no header, no dock and no way out — the user could only force-quit.
 * This catches it and always offers a way back into the class. The message is
 * written for students, never for developers — no error text on screen.
 */
export class MeetingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[udyog-meeting] render crash", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center px-6"
        data-testid="meeting-crash-card"
      >
        <div className="w-full max-w-sm text-center">
          <UdyogLogo size={38} className="justify-center mb-7" />
          <h1 className="font-display text-2xl font-semibold text-white mb-2">
            Your class is still running
          </h1>
          <p className="text-sm text-white/45 mb-8">
            The screen just needs a moment to load again. Tap below and you will be right back with
            everyone.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="w-full h-12 rounded-full bg-emerald-400 text-black text-[13px] font-semibold tracking-wide transition-transform duration-200 hover:-translate-y-0.5"
            data-testid="meeting-crash-rejoin-btn"
          >
            REJOIN CLASS
          </button>
        </div>
      </div>
    );
  }
}
